/**
 * RYTE feature flag key-value definitions. Pure constants — no imports.
 * Spread into FEATURE_FLAGS in app-constants.js; referenced by RYTE_FLAGS
 * in featureFlags.ts.
 */
export const RYTE_FEATURE_FLAGS = {
  ENABLE_RYTE: "enableRYTE",
  ENABLE_RYTE_METRICS: "enableRYTEMetrics",
  ENABLE_RYTE_MOCK_DATA: "enableRyteMockData",
  ENABLE_RYTE_STAGE_TRAILER: "enableRYTEStageTrailer",
  ENABLE_RYTE_ATTACH_TRAILER: "enableRYTEAttachTrailer",
  ENABLE_RYTE_DOCK_ORCHESTRATION_REDIRECT: "enableRYTEDockOrchestrationRedirect",
  ENABLE_RYTE_GOAL_QUERY_FANOUT: "enableRYTEGoalQueryFanout",
  // Direction-gated create/update flags (default-off). UPDATE flags gate
  // drag-edit + action-menu by goal direction (block-if-ANY for cross-dock).
  // CREATE flags gate queue→gantt drop by card direction. IB=UNLOAD, OB=LOAD.
  ENABLE_RYTE_UPDATE_IB: "enableRYTEUpdateIB",
  ENABLE_RYTE_UPDATE_OB: "enableRYTEUpdateOB",
  ENABLE_RYTE_CREATE_IB: "enableRYTECreateIB",
  ENABLE_RYTE_CREATE_OB: "enableRYTECreateOB",
  // Cancel-VRID gates (default-off). Direction-split like update/create.
  // Action-menu only — no drag/CSS affordance.
  ENABLE_RYTE_CANCEL_IB: "enableRYTECancelIB",
  ENABLE_RYTE_CANCEL_OB: "enableRYTECancelOB",
  // IB Door to IB Door Transfer (default-off). Gates the action and modal.
  ENABLE_RYTE_IB_DOOR_TRANSFER: "enableRYTEIbDoorTransfer",
  // Planned IB Door Transfer (default-off). Effective gate requires
  // ENABLE_RYTE_IB_DOOR_TRANSFER AND this flag both on.
  ENABLE_RYTE_PLANNED_IB_DOOR_TRANSFER: "enableRYTEPlannedIbDoorTransfer",
} as const;
